// SmartApp QC
export const fbConf = {
	apiKey: "AIzaSyCcaUtWD4m5usuKWr_UtxRCABrCpI9If2I",
	authDomain: "smartapp-79daf.firebaseapp.com",
	databaseURL: "https://smartapp-79daf.firebaseio.com",
	storageBucket: "smartapp-79daf.appspot.com",
	messagingSenderId: "339805797787"
};

//Smart Demo
/*export const fbConf = {
	apiKey: "AIzaSyACEv7kmkuVTwfaSeDvMe3kITqlA95taLA",
	authDomain: "smartappdemo-b1a7e.firebaseapp.com",
	databaseURL: "https://smartappdemo-b1a7e.firebaseio.com",
	storageBucket: "smartappdemo-b1a7e.appspot.com",
	messagingSenderId: "134015616208"
};*/

//El Rod
/*export const fbConf = {
	apiKey: "AIzaSyC88j7-D9b4dfhBrKtv9fCVnlfJy02XhPE",
	authDomain: "elrod-8ac32.firebaseapp.com",
	databaseURL: "https://elrod-8ac32.firebaseio.com",
	storageBucket: "elrod-8ac32.appspot.com",
	messagingSenderId: "826036443706"
};*/

//El Rancho
/*export const fbConf = {
	apiKey: "AIzaSyALoVy6ZIhIYOyPYxdP23S0JR9yz833eR4",
	authDomain: "elrancho-7e155.firebaseapp.com",
	databaseURL: "https://elrancho-7e155.firebaseio.com",
	storageBucket: "elrancho-7e155.appspot.com",
	messagingSenderId: "264776478085"
};*/

//SmartCare
// export const fbConf = {
// 	apiKey: "AIzaSyDxOube52a5ZAeIhwzm2f_3SQSz4DOKqv0",
//     authDomain: "smartcare-b7c88.firebaseapp.com",
//     databaseURL: "https://smartcare-b7c88.firebaseio.com",
//     storageBucket: "smartcare-b7c88.appspot.com",
//     messagingSenderId: "132706595349"
// };


// WEBPACK FOOTER //
// ./src/config/firebase-config.ts